<ng-container *transloco="let t; prefix: 'fuelReconciliation'">
<div class="main-table fuel-recon-table">
  <table class="table fuel-to-recon-table">
    <thead>
      <tr>
        <th class="asset">
          <div class="sort-btn">
            {{ t('toReconcileTable.asset') }}
            <button class="filter-button" (click)="sortByColumn('assetName')">
              <img src="assets/images-fuel/filterIconMainTable.svg" alt="filter-btn" />
            </button>
          </div>
        </th>
        <th>
          <div class="sort-btn">
            {{ t('toReconcileTable.intakeTime') }}
            <button class="filter-button" (click)="sortByColumn('fuelSlipDateTime')">
              <img src="assets/images-fuel/filterIconMainTable.svg" alt="filter-btn" />
            </button>
          </div>
        </th>
        <th>
          <div class="sort-btn">
            {{ t('toReconcileTable.intakeLocation') }}
            <button class="filter-button" (click)="sortByColumn('fuelIntakeLocation')">
              <img src="assets/images-fuel/filterIconMainTable.svg" alt="filter-btn" />
            </button>
          </div>
        </th>
        <th>
          <div class="sort-btn">
            {{ t('toReconcileTable.fuelProbeReading') }}
            <button class="filter-button" (click)="sortByColumn('fuelProbeReading')">
              <img src="assets/images-fuel/filterIconMainTable.svg" alt="filter-btn" />
            </button>
          </div>
        </th>
        <th>
          <div class="sort-btn">
            {{ t('toReconcileTable.reconcile') }}
          </div>
        </th>
      </tr>
    </thead>

    @if (isLoading) {
      <tbody>
        <tr>
          <td colspan="5">
            <div class="spinner-container">
              <span class="spinner-border text-light"></span>
            </div>
          </td>
        </tr>
      </tbody>
    } @else {
      <tbody>
        @if (!fuelToReconcile?.length && hasError) {
          <tr>
            <td colspan="5" class="no-data">
              <app-error-state></app-error-state>
            </td>
          </tr>
        } @else if (!fuelToReconcile?.length) {
          <tr>
            <td colspan="5" class="no-data">
              <app-empty-state></app-empty-state>
            </td>
          </tr>
        }
        @for (fuel of fuelToReconcile; track fuel.fuelSlipId; let i = $index) {
          <tr>
            <td class="asset"><strong>{{ fuel.assetName }}</strong></td>
            <td class="fuel-recon-cell">{{ fuel.fuelSlipDateTime | date: 'dd/MM/yyyy HH:mm:ss.SSS' }}</td>
            <td class="fuel-recon-cell">{{ fuel.fuelIntakeLocation }}</td>
            <td class="fuel-recon-cell">{{ fuel.fuelProbeReading }} ℓ</td>
            <td class="fuel-recon-cell">
              <div class="search-menu-lists">
                <div class="upload-button-wrap d-flex align-items-center">
                  <div class="upload-button d-flex align-items-center justify-content-center"
                    (click)="toggleRowExpansion(i); $event.stopPropagation()">
                    <img src="assets/images-fuel/plusIcon.svg" alt="">{{ t('toReconcileTable.addFuelSlip') }}</div>
                </div>
              </div>
            </td>
          </tr>
          @if (expandedRowIndex === i) {
            <tr class="fuel-details-row">
              <td colspan="6">
                <div class="fuel-details-content">

                  <div class="field-group">
                    <label>{{ t('toReconcileTable.attach') }}</label>
                    <input type="file" id="fuelSlipFile{{i}}" hidden #fileInput (change)="onFileSelected($event)">
                    <p class="browse-files-label">
                      {{ selectedFile ? selectedFile.name : t('toReconcileTable.attachHint') }}
                      <button type="button" class="browse-files-btn" (click)="fileInput.click()">{{ t('toReconcileTable.browseFiles') }}</button>
                    </p>
                  </div>

                  <div class="field-group">
                    <label>{{ t('toReconcileTable.volumeInLitres') }}</label>
                    <input type="number" id="volumeInput{{i}}" class="volume-input" [placeholder]="t('toReconcileTable.volumeInLitres')"
                      [(ngModel)]="reconcileFuelSlipRequest.amount" min="0">
                  </div>

                  <div class="field-group">
                    <label>{{ t('toReconcileTable.costInputType') }}</label>
                    <div class="cost-type-dropdown common-drop-down dropdown">
                      <input type="text" id="costTypeInput{{i}}" class="dropdown-toggle cost-type-input"
                        [value]="costType || t('toReconcileTable.selectCostInputType')" readonly data-bs-toggle="dropdown"
                        aria-expanded="false" />
                      <ul class="dropdown-menu cost-type-menu">
                        <li>
                          <button class="dropdown-item" type="button" (click)="selectCostType('Cost/ℓ')">{{ t('toReconcileTable.costPerLitre') }}</button>
                        </li>
                        <li>
                          <button class="dropdown-item" type="button" (click)="selectCostType('Total Cost')">{{ t('toReconcileTable.totalCost') }}</button>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div class="field-group">
                    <label>{{ t('toReconcileTable.fuelSlipAmount') }}</label>
                    <div class="d-flex align-items-center">
                      <div class="currency-dropdown common-drop-down dropdown">
                        <button type="button" class="dropdown-toggle currency-input" data-bs-toggle="dropdown"
                          aria-expanded="false">
                          <div class="currency-display-content">
                            @if (selectedCurrency) {
                              <app-country-flag [countryCode]="selectedCurrency.code"
                                [name]="selectedCurrency.name" [size]="18" [rounded]="true"></app-country-flag>
                            }
                            <span class="currency-text">{{ selectedCurrency?.code || t('toReconcileTable.selectCurrency') }}</span>
                          </div>
                        </button>
                        <ul class="dropdown-menu currency-list-menu">
                          <li class="currency-search-wrapper">
                            <div class="input-group">
                              <span class="search-icon" aria-hidden="true"></span>
                              <input type="text" class="currency-search-input" [placeholder]="t('toReconcileTable.searchCurrency')"
                                [(ngModel)]="currencySearchTerm" (ngModelChange)="filterCurrencies()"
                                (click)="$event.stopPropagation()" />
                            </div>
                          </li>
                          @for (currency of filteredCurrencies; track currency.id) {
                            <li class="currency-item" [class.selected]="selectedCurrency?.code === currency.code">
                              <button class="dropdown-item" type="button" (click)="selectCurrency(currency)">
                                <div class="currency-item-content">
                                  <app-country-flag [countryCode]="currency.code" [name]="currency.name"
                                    [rounded]="true"></app-country-flag>
                                  <div class="currency-info">
                                    <span class="currency-code">{{ currency.code }}</span>
                                    <span class="currency-name">{{ currency.name }}</span>
                                  </div>
                                </div>
                                <div class="currency-checkbox" [class.checked]="selectedCurrency?.code === currency.code"></div>
                              </button>
                            </li>
                          } @empty {
                            <li class="no-results">{{ t('toReconcileTable.noCurrenciesFound') }}</li>
                          }
                        </ul>
                      </div>
                      <input type="number" id="amountInput{{i}}" class="amount-input" placeholder="0.00"
                        [(ngModel)]="reconcileFuelSlipRequest.cost" min="0">
                    </div>
                  </div>

                  <div class="field-group field-group--actions">
                    <button class="reconcile-btn" [disabled]="
                      reconcileFuelSlipRequest.amount == null ||
                      costType == null ||
                      reconcileFuelSlipRequest.cost == null ||
                      selectedCurrency == null ||
                      reconcileFuelSlipRequest.amount <= 0 ||
                      reconcileFuelSlipRequest.cost <= 0
                    " (click)="reconcileFuelSlipAsync(fuel)">
                      @if (isLoading) {
                        <span class="spinner-border spinner-border-sm"></span>
                      } @else {
                        <img src="assets/icons/update-icon.svg" alt="" style="width:16px;height:16px;" />
                      }
                      {{ t('toReconcileTable.reconcile') }}
                    </button>
                    <button class="close-row-btn" (click)="toggleRowExpansion(i); $event.stopPropagation()">✕</button>
                  </div>

                </div>
              </td>
            </tr>
          }
        }
      </tbody>
    }
  </table>
</div>
<div class="d-flex align-items-center justify-content-between bottom-options">
  <p class="pageination-text">{{ 'common.showingOutOf' | transloco: { current: currentItems, total: totalItems } }}</p>
  <app-pagination [totalPages]="numberOfPages" [currentPage]="currentPage"
    (pageChange)="createPagination($event)"></app-pagination>
  <div class="export-listing" [class.invisible]="true">
    <div class="common-drop-down dropdown">
      <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdown-button" data-bs-toggle="dropdown"
        aria-expanded="false">
        {{ 'common.export' | transloco }} <i><img src="./assets/images-fuel/downloadIcon.svg" alt="export-icon" /></i>
      </button>
      <ul class="dropdown-menu" aria-labelledby="dropdown-button">
        <li><a class="dropdown-item">{{ t('export.exportAsPdf') }}</a></li>
        <li><a class="dropdown-item">{{ t('export.exportAsCsv') }}</a></li>
        <li><a class="dropdown-item">{{ t('export.sendViaEmail') }}</a></li>
      </ul>
    </div>
  </div>
</div>
</ng-container>
